import type { Sequence } from "./Sequence"

export type AsyncSequence<T> = AsyncIterable<T> | Sequence<T>
